import { apiAddress } from "../../config/server";
import { Role } from "../../types/persons/Role";
import { ApiBase } from "./baseApi";

export default class SearchApi extends ApiBase {
  static SearchApiAddress = `${apiAddress}/api/search/`;

  static searchRefereesByShiftAndGame(
    role: Role,
    shift: string,
    game: string,
    shiftSessionId?: string,
  ): Promise<{ available: string[]; maybe: string[] }> {
    return this.get<{ available: string[]; maybe: string[] }>(
      `${
        SearchApi.SearchApiAddress
      }available-officials${this.prepareQueryParams({
        shiftId: shift,
        gameId: game,
        role,
        shiftSessionId,
      })}`,
    ).then((resp) => resp.data.data);
  }
}
